import React from "react";
import styled from "styled-components";
import { Link } from "../link";
import { grid } from "styled-components-grid";
// import { motion } from "framer-motion";
// import { useTheme } from "styles";

// const circleMotion = {
//   rest: {
//     scale: 1.0001,
//     backgroundColor: "#F67E7D",
//     color: "#000",
//   },
//   hover: {
//     scale: 1.1,
//     backgroundColor: "#F67E7D",
//     color: "#fff",
//   },
//   tap: {
//     rotate: -45,
//     transition: {
//       duration: 0.4,
//       type: "tween",
//       ease: "easeOut",
//     },
//   },
// };

const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1080px;
  position: relative;
  padding: 1em 25px 1em 25px;
  @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    padding: 2.5em 30px 3.5em 30px
  }
  ${grid({})}
  .left {
    ${grid.unit({ size: { sm: 1 / 1, md: 1 / 2 } })}
    display: flex;
    justify-content: center;
    align-items: center;
    .head {
      font-size: 36px;
      @media (min-width: ${(props) => props.theme.breakpoints.xl}px) {
        font-size: 48px;
        margin: 25px auto;
      }
    }
  }
  .right {
    ${grid.unit({ size: { sm: 1 / 1, md: 1 / 2 } })}
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    font-size: 36px;
    @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
      padding: 0px;
      font-size: 48px;
    }
    transform: translate(-20px, 0px);
    .head {
      text-align: left;
      @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
        margin: 25px auto;
        text-align: right;
      }
      z-index: 2;
    }
    .circle {
      border-radius: 100%;
      transform: translate(100px, 0px);
      padding: 6px 13px;
      @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
        transform: translate(132px, 0px);
        padding: 8px 17px;
      }
      background: ${(props) => props.theme.colors.froly};
      position: absolute;
      z-index: 1;
    }
  }
`;
// &:after {
//   content: "";
//   width: 2em;
//   height: 2em;
//   right: 120px;
//   border-radius: 100%;
//   background: ${(props) => props.theme.colors.froly};
//   position: absolute;
//   display: inline;
//   z-index: -1;
// }
// transform-origin: 20% 40%;
// 


const CTA: React.FC<Props> = ({ title, sub, link, linkText }) => {
  return (
    <Link to={link || "/contact"} style={{ width: "100%" }}>
      <Wrapper>
        <div className="left">
          <div>
            <p>{sub || "Ready, needing help or curious?"}</p>
            <div className="head">{title || "Let’s talk, say Hi!"}</div>
          </div>
        </div>
        <div className="right">
          <div className="head">{linkText || "Contact"}</div>
          <div className="circle">us</div>
        </div>
      </Wrapper>
    </Link>
  );
};

export { CTA };

export interface Props {
  title?: string;
  sub?: string;
  link?: string;
  linkText?: string;
}
